document.addEventListener("DOMContentLoaded", function() {
    // Get the current URL
    const currentUrl = window.location.href;

    // Split the URL by the "/collections/" string
    const collectionPart = currentUrl.split('/collections/')[1];

    // Check if there is something after the collection name
    const hasFilters = collectionPart.split('/').length > 2;

    // Example of how to handle it
    if (hasFilters) {
        console.log("The collection has filters applied");
        // You can execute any additional logic here
        hideProductGridItems();
    } else {
        console.log("The collection has no filters");
    }
});

// Function that hides all elements with the class .productgriditem
function hideProductGridItems() {
    const productGridItems = document.querySelectorAll('.custom-content-image');
    
    productGridItems.forEach(item => {
        item.style.display = 'none'; // Hide each product
    });
}

// Detect active filters with JavaScript:
document.addEventListener('DOMContentLoaded', function() {
  const activeFilters = document.querySelectorAll('li.collection-container.active.selected');
  const activeFiltersLists = document.querySelectorAll('.active-filters-list'); // Select all active filter lists
  const filtersContainers = document.querySelectorAll('.active-filters-container'); // Select all filter containers

  // Create a set to store unique filter names
  const filterSet = new Set();

  // Loop through active filters
  activeFilters.forEach(function(filter) {
    const filterName = filter.querySelector('.collection-name a').textContent.trim();

    // Exclude the value "Shop All Men"
    if (filterName !== "Shop All Men") {
      filterSet.add(filterName); // Add to set only if not already present
    }
  });

  // If there is at least one active filter, show the filter sections
  if (filterSet.size > 0) {
    filtersContainers.forEach(function(container) {
      container.style.display = 'block'; // Show all containers
    });

    // Clear all active filter lists
    activeFiltersLists.forEach(function(list) {
      list.innerHTML = ''; // Clear the filter lists
    });

    // Iterate over the set and add each unique filter to the active filter lists
    filterSet.forEach(function(filterName) {
      activeFiltersLists.forEach(function(list) {
        const li = document.createElement('li');
        li.textContent = filterName;
        list.appendChild(li); // Add to each filter list
      });
    });

  } else {
    // If no active filters, hide all sections
    filtersContainers.forEach(function(container) {
      container.style.display = 'none'; // Hide all containers
    });
  }
});
